<template>
    <div
        class="ag-cell-label-container"
        role="presentation"
    >
        <span
            ref="eMenu"
            class="ag-header-icon ag-header-cell-menu-button"
        ></span>
        <span
            ref="eFilterButton"
            class="ag-header-icon ag-header-cell-filter-button"
        ></span>
        <div
            ref="eLabel"
            class="ag-header-cell-label"
            role="presentation"
        >
            <span
                v-show="!props.readonly"
                ref="eText"
                class="ag-header-cell-text me-2"
                role="columnheader"
            >
                <form>
                    <select
                        class="form-select"
                        v-model="selectedOption"
                    >
                        <template
                            v-for="option in visibleOptions"
                            :key="option.value"
                        >
                            <optgroup
                                v-if="option.options !== null && option.options!.length > 0"
                                :label="$tm(option.text)"
                                :data-i18n="option.text"
                            >
                                <option
                                    v-for="subOption in option.options"
                                    :key="subOption.value!"
                                    :value="subOption"
                                >
                                    {{ $tm(subOption.value!) }}
                                </option>
                            </optgroup>
                            <option
                                v-else
                                :value="option"
                            >
                                {{ $tm(option.value!) }}
                            </option>
                        </template>
                    </select>
                </form>
            </span>
            <span
                v-if="props.readonly && !caption"
                class="flex-fill"
                >{{ $tm(selectedOption.value!) }}</span
            >
            <span
                v-else
                class="flex-fill"
                >{{ caption! }}</span
            >
            <ColumnFilterButton
                :grid="grid"
                :column="column"
                :value-getter="(value: IImportValue) => value.Value"
            />
        </div>
    </div>
</template>

<script setup lang="ts" generic="TRowData">
import type { IGridCompExposed } from '../Grid/Classes';
import type { IHeaderComponentParamsColumn } from '../Grid/Classes/params/IHeaderComponentParamsColumn';
import type { ImportOption } from './IImportOption';
import { watch, ref, computed } from 'vue';
import type { IImportValue } from './IImportValue';
import ColumnFilterButton from '../Grid/Headers/Filters/ColumnFilterButton.vue';

const props = defineProps<{
    grid: IGridCompExposed<TRowData>;
    column: IHeaderComponentParamsColumn;
    displayName?: string;

    /**
     * The caption of the header
     * @requires readonly to be true
     */
    caption?: string;
    /**
     * If the header is readonly
     * This will only render the value of the selected option
     */
    readonly: boolean;

    /**
     * The options for the import
     * This is the mapping file between the columns and fields
     */
    options: ImportOption[];

    // TODO: Why do we need params here? Where does it come from?
    // I think we use this wrapper so we get reactive properties
    params: any;
}>();

const selectedOption = ref<ImportOption>(props.params.value);
selectedOption.value.column = props.column.colId;
const emit = defineEmits(['update:modelValue']);

const visibleOptions = computed(() => {
    return props.options.filter((o) => o.visible);
});

watch(
    () => selectedOption.value,
    (value) => {
        emit('update:modelValue', props.params.column, value);
        props.params.onValueChange(selectedOption, props.params.column);
    },
);
</script>
